import { Mapper } from "../../../../core/base";
import { LookupWebEntity } from "./lookup-web-entity";
import { Lookup } from "../../../../core/domain";

export class LookupWebRepositoryMapper extends Mapper<LookupWebEntity, Lookup> {
  mapFrom(param: LookupWebEntity): Lookup {
    return {
      id: param.id,
      name: param.name
    };
  }

  mapTo(param: Lookup): LookupWebEntity {
    return {
      id: param.id,
      name: param.name
    };
  }

}
